"use strict";function preview$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.preview$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.cspace.preview";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"3.0.0"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.7.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.7.0"},_a)),exports.preview$=preview$,exports.default=preview$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/cspace/preview.js
// module id = 940
// module chunks = 106